import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/**
 * 验收单列表（接口 pms.queryAcceptanceOrder）
 * 说明：
 * - 默认使用当前小区 communityId
 * - 默认 initiatorType 为 '-1'
 * - 返回统一结构 { data, total }
 */
export function listAcceptanceOrders(params = {}) {
  return new Promise((resolve, reject) => {
    const baseParams = {
      communityId: params.communityId || getCommunityId(),
      initiatorType: params.initiatorType || '-1',
      page: params.page || 1,
      row: params.row || 10
    }

    const queryParams = { ...baseParams, ...params }

    request({
      url: '/app/pms.queryAcceptanceOrder',
      method: 'get',
      params: queryParams
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const list = Array.isArray(res.data) ? res.data : []
        const total = typeof res.total === 'number'
          ? res.total
          : (typeof res.records === 'number' ? res.records : list.length)
        resolve({
          data: list,
          total
        })
      } else {
        reject(new Error(res.msg || '获取验收单列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存或更新验收单
 */
export function saveOrUpdateAcceptanceOrder(data) {
  return new Promise((resolve, reject) => {
    const payload = {
      ...data
    }
    if (!payload.communityId) {
      payload.communityId = getCommunityId()
    }

    request({
      url: '/app/pms.saveOrUpdateAcceptanceOrder',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存验收单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除验收单
 */
export function deleteAcceptanceOrder(data) {
  return new Promise((resolve, reject) => {
    const payload = {
      ...data
    }
    if (!payload.communityId) {
      payload.communityId = getCommunityId()
    }

    request({
      url: '/app/pms.deleteAcceptanceOrder',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除验收单失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
